import AntSelect, {
  AntOption,
} from "../../../../../../../containers/backend/common/component/AntSelect";
import {
  DatePickerComponent,
  FormWrapperInputComponent,
} from "../../../../../../../containers/backend/common/component/Index";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Input from "../../../../../../../containers/backend/common/component/Input";
import { DATE_TIME_FORMAT, IDENTITYTYPE, NATIONALITY } from "../../../../../../../constants/Define";
import { DatePicker, Tooltip } from "antd";
import * as Func from "../../../../../../../helpers/functions";
import moment from "moment";

class CustomerFormItem extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { t, index, item, validation } = this.props;

    return (
      <div className="mt-3">
        <div>Thông tin khách hàng {index + 1}:</div>
        <div className="d-flex align-items-end mt-2">
          <FormWrapperInputComponent
            className="form-group mr-1"
            isValidation={true}
            dataValidation={item.lastName}
            validation={validation[index].lastName}
          >
            <Input
              type="text"
              placeholder={t("item.order.lastName") + " " + t("item.order.require")}
              onChange={(e) => this.onChange("lastName", e.target.value)}
              value={item.lastName}
            />
          </FormWrapperInputComponent>

          <FormWrapperInputComponent
            className="form-group mr-1"
            isValidation={true}
            dataValidation={item.firstName}
            validation={validation[index].firstName}
          >
            <Input 
              type="text"
              placeholder={t("item.order.firstName") + " " + t("item.order.require")}
              onChange={(e) => this.onChange("firstName", e.target.value)}
              value={item.firstName}
             />
          </FormWrapperInputComponent>

          <FormWrapperInputComponent className="form-group mr-1">
            <DatePicker
              value={item.dateOfBirth && new moment(item.dateOfBirth, DATE_TIME_FORMAT.SHORT_DATE_EXPORT)}
              onChange={(e) => this.onChange("dateOfBirth", e.format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT))}
              format={DATE_TIME_FORMAT.SHORT_DATE}
              placeholder={t("item.order.dateOfBirth")}
            />
          </FormWrapperInputComponent>

          <FormWrapperInputComponent className="form-group mr-1"
              isValidation={true}
              dataValidation={item.phoneNumber}
              validation={validation[index].phoneNumber}
            >
            <Input type="text"
              value={item.phoneNumber}
              onChange={(e) => this.onChange("phoneNumber", e.target.value)}
              placeholder={t("item.order.phoneNumber")} />
          </FormWrapperInputComponent>

          <FormWrapperInputComponent className="form-group">
            <AntSelect
              className="select-group vw-admin-order-identity-type"
              showArrow
              showSearch
              allowClear
              placeholder={t("item.order.identityType")}
              value={item.identityType}
              onChange={(e) => this.onChange("identityType", e)}
              style={{ width: "70px" }}
              filterOption={this.selectFilterSearch}
            >
              {IDENTITYTYPE.map((g) => (
                <AntOption key={g.key} value={g.value}>
                  <Tooltip title={g.label} placement="left">
                    {g.label}
                  </Tooltip>
                </AntOption>
              ))}
            </AntSelect>
          </FormWrapperInputComponent>

          <FormWrapperInputComponent className="form-group mr-1">
            <Input type="text" className="vw-admin-order-identity-detail"
              value={item.identityDetail}
              onChange={(e) => this.onChange("identityDetail", e.target.value)}
              placeholder={t("item.order.identityDetail")} />
          </FormWrapperInputComponent>

          <FormWrapperInputComponent className="form-group mr-1">
            <AntSelect
              className="select-group"
              showArrow
              showSearch
              allowClear
              placeholder={t("item.order.national")}
              value={item.national}
              onChange={(e) => this.onChange("national", e)}
              style={{ width: "120px" }}
              filterOption={this.selectFilterSearch}
            >
              {NATIONALITY.map((g) => (
                <AntOption key={g.key} value={g.key}>
                  <Tooltip title={g.value} placement="left">
                    {g.value}
                  </Tooltip>
                </AntOption>
              ))}
            </AntSelect>
          </FormWrapperInputComponent>

          <FormWrapperInputComponent className="form-group">
            <Input type="text"
              value={item.placeOfBirth}
              onChange={(e) => this.onChange("placeOfBirth", e.target.value)}
              placeholder={t("item.order.placeOfBirth")} />
          </FormWrapperInputComponent>
        </div>
      </div>
    );
  }

  onChange = (fieldName, value) => {
    this.props.onChange(fieldName, value, this.props.index);
  };

  selectFilterSearch = (input, option) => {
    const resultText = option.props.children.props.children;
    return this.getResultSearch(resultText, input);
  };

  getResultSearch = (result, input) => {
    const optionText = Func.vietnameseStringToUnicode(result.toLowerCase());
    const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
    return optionText.indexOf(inputText) >= 0;
  };
}

export default withTranslation()(CustomerFormItem);
